/* eslint-disable no-nested-ternary */
import {
  SchemaVersionNotFound,
  SchemaExtensionNotFound,
  NamespaceNotFound,
  NamespaceAlreadyExists,
  ForbiddenAccessInternalAPI,
  InvalidParameterError,
  NoAccessPermission,
  SchemaNotFound,
} from './exceptions';
const _ = require('underscore');

export const AUTH_URL = 'authentication/v1/authorize';
export const FORGE_BASE_URL = 'https://developer-stg.api.autodesk.com';
export const FORGESCHEMA_BASE_URL = 'https://developer-stg.api.autodesk.com/schema/v1';
export const BIM360_BASE_URL = 'https://developer.api.autodesk.com/hq/v1';
export const FORGEDM_BASE_URL = 'https://developer.api.autodesk.com/project/v1';
export const GITHUB_BASE_URL = 'git';
export const GITHUB_REPOS = 'HFDMSchemas';
export const GITHUB_OWNER = 'forge';
export const FORGESCHEMA_CDN_URL = 'https://d2l8zltif9w3t9.cloudfront.net';

export const defaultFetchOpts = {};
export const defaultHeaders = {};

export const FSS_LIBRARY_PERMISSION_ADMIN = 'admin';
export const FSS_LIBRARY_PERMISSION_WRITE = 'write';
export const FSS_LIBRARY_PERMISSION_READ = 'read';

export const PermissionEnum = Object.freeze({
  UNKNOWN: -1,
  NOT_EXIST: 0,
  SCHEMA_AUTHOR: 1,
  NAMESPACE_ADMIN: 2,
  SCHEMA_READER: 3,
});

export const PublishStatusEnum = Object.freeze({
  UNKNOWN: -1,
  NOT_PUBLISHED: 0,
  SCHEMA_DIFFERENT: 1,
  PUBLISHED: 2,
  UPDATING: 3,
});

export const ForgeEnvironmentEnum = Object.freeze({
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
});

const completeUrl = (host, path) => {
  const url = `${host}${path}`;
  // add query here
  return url;
};

const makeFetchOpts = (opts = {}) => {
  const userHeaders = opts.headers || {};
  delete opts.headers;
  const headers = new Headers({
    ...defaultHeaders,
    ...userHeaders,
  });
  return { ...defaultHeaders, ...opts, headers };
};

export const makeFetch = (host, path, opts = {}) => {
  const url = completeUrl(host, path, opts.query);
  const fetchOpts = makeFetchOpts(opts);
  return fetch(url, fetchOpts)
    .then((resp) => {
      return resp.json();
    })
    .then((json) => {
      if (json.errors !== undefined && Array.isArray(json.errors) && json.errors.length > 0) {
        const error = json.errors[0];
        switch (error.code) {
          case '1034':
            throw new SchemaVersionNotFound(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          case '1033':
            throw new SchemaExtensionNotFound(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          case '178':
            throw new ForbiddenAccessInternalAPI(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          case '1038':
            throw new NamespaceNotFound(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          case '1040':
            throw new NamespaceAlreadyExists(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          case '122':
            throw new InvalidParameterError(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          case '404':
            throw new SchemaNotFound(error.id, error.code, error.meta.errorMessage, error.detail);
          case '401':
            throw new NoAccessPermission(
              error.id,
              error.code,
              error.meta.errorMessage,
              error.detail
            );
          default:
            break;
        }
      }
      if (json.error) {
        throw json.error;
      }
      return json;
    });
};
export const makeAuthFetch = (token, host, path, opts = {}) => {
  const fetchOpts = {
    ...opts,
    headers: {
      ...opts.headers,
      Authorization: `Bearer ${token}`,
    },
  };
  return makeFetch(host, path, fetchOpts);
};

export const setSchemaPublishStatus = (env, path, status) => {
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }

  if (fssStatusLatest[path] === undefined) {
    fssStatusLatest[path] = {
      publishstatus: PublishStatusEnum.UNKNOWN,
    };
  }
  fssStatusLatest[path].publishstatus = status;
  if (env === ForgeEnvironmentEnum.STAGING) {
    localStorage.FSSStgStatus = JSON.stringify(fssStatusLatest);
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    localStorage.FSSProdStatus = JSON.stringify(fssStatusLatest);
  }
};

export const getSchemaPublishStatus = (env, path) => {
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }

  const paths = Object.keys(fssStatusLatest);
  // only checks the publish status for files, and returns unknown for folders.
  const pathData = paths.find((p) => p.indexOf('.json') >= 0 && path.indexOf(p) === 0);
  return pathData === undefined
    ? PublishStatusEnum.UNKNOWN
    : fssStatusLatest[pathData].publishstatus;
};

export const getSchemaIndexStatus = (env, path) => {
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }

  const paths = Object.keys(fssStatusLatest);
  // only checks the publish status for files, and returns unknown for folders.
  const pathData = paths.find((p) => p.indexOf('.json') >= 0 && path.indexOf(p) === 0);
  return pathData === undefined ? PublishStatusEnum.UNKNOWN : fssStatusLatest[pathData].indexstatus;
};

export const setSchemaIndexStatus = (env, path, status) => {
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }

  if (fssStatusLatest[path] === undefined) {
    fssStatusLatest[path] = {
      indexstatus: PublishStatusEnum.UNKNOWN,
    };
  }
  fssStatusLatest[path].indexstatus = status;
  if (env === ForgeEnvironmentEnum.STAGING) {
    localStorage.FSSStgStatus = JSON.stringify(fssStatusLatest);
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    localStorage.FSSProdStatus = JSON.stringify(fssStatusLatest);
  }
};

/**
 * Gets the dependencies of a schema
 * @param {Object} inputSchema A schema
 * @return {*} dependencies of a schema
 */
const getDependencies = (inputSchema) => {
  const child = JSON.parse(JSON.stringify(inputSchema));
  let dependicies = [];

  Object.freeze(child);
  const hasInherits = child.hasOwnProperty('inherits') && _.isArray(child['inherits']);
  const hasConstants = child.hasOwnProperty('constants') && _.isArray(child['constants']);

  if (hasInherits) {
    if (_.isString(child['inherits'])) {
      dependicies = [child['inherits']];
    } else {
      dependicies = child['inherits'].slice();
    }
  }

  if (hasConstants) {
    for (let k = 0; k < child['constants'].length; k++) {
      const constant = child['constants'][k];
      if (constant['typeid']) {
        dependicies.push(constant['typeid']);
      }
      const hasValue = constant.hasOwnProperty('value') && _.isObject(constant['value']);
      if (hasValue) {
        Object.keys(constant['value']).forEach(function (key) {
          dependicies.push(key);
        });
      }

      const hasTypedValue =
        constant.hasOwnProperty('typedValue') && !_.isUndefined(constant['typedValue']);
      if (hasTypedValue) {
        const constantValue = constant['typedValue'];
        if (_.isObject(constantValue) && !_.isArray(constantValue)) {
          if (constantValue['typeid']) {
            dependicies.push(constantValue['typeid']);
          }
        } else {
          for (let z = 0; z < constantValue.length; z++) {
            if (constantValue[z]['typeid']) {
              dependicies.push(constantValue[z]['typeid']);
            }
          }
        }
      }
    }
  }
  return dependicies;
};

/**
 * Sorts an array of schemas based on dependicies.
 * @param {*} inputSchemas The an array of schemas
 * @return {*} Returns the sorted list of schemas
 */
export const sortSchemas = (inputSchemas) => {
  // sort by versions at first to make sure we publish schema in the order of versions.
  const schemas = inputSchemas.slice(0);
  schemas.sort((a, b) => {
    const aid = a.typeid.split('-')[0];
    const av = a.typeid.split('-')[1];
    const bid = b.typeid.split('-')[0];
    const bv = b.typeid.split('-')[1];
    if (aid === bid) {
      // disable-eslint no-nested-ternary
      return av < bv ? -1 : av > bv ? 1 : 0;
    } else {
      return aid < bid ? -1 : 1;
    }
  });

  let swapHappened = true;
  while (swapHappened) {
    swapHappened = false;
    for (let i = 0; i < schemas.length; i++) {
      const child = schemas[i];
      const dependicies = getDependencies(child);
      if (dependicies.length > 0) {
        for (let j = schemas.length; j > i; --j) {
          if (schemas[j] === undefined || schemas[j] === null) {
            continue;
          }
          const ifDependant = dependicies.indexOf(schemas[j].typeid) !== -1;

          if (ifDependant) {
            schemas[i] = schemas[j];
            schemas[j] = child;
            swapHappened = true;
            break;
          }
        }
      }
    }
  }
  return schemas;
};

export const setNamespacePermission = (env, path, permissions) => {
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }
  if (fssStatusLatest[path] === undefined) {
    fssStatusLatest[path] = {
      permissions: [],
    };
  }
  fssStatusLatest[path].permissions = permissions;
  if (env === ForgeEnvironmentEnum.STAGING) {
    localStorage.FSSStgStatus = JSON.stringify(fssStatusLatest);
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    localStorage.FSSProdStatus = JSON.stringify(fssStatusLatest);
  }
};

export const getPathPermission = (env, path) => {
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }
  const pathes = Object.keys(fssStatusLatest);
  const pathData = pathes.find((p) => {
    if (p.indexOf('.json') >= 0) {
      return false;
    }
    return (
      path.indexOf(p) === 0 &&
      path.substr(p.length + 1).indexOf('/') === -1 &&
      fssStatusLatest[p].permissions
    );
  });
  return pathData === undefined ? [] : fssStatusLatest[pathData].permissions || [];
};

const emptyPermission = { Subjects: { O2User: [] } };

export const mergePermissions = (p1, p2) => {
  const newPermission = [];
  [FSS_LIBRARY_PERMISSION_ADMIN, FSS_LIBRARY_PERMISSION_WRITE, FSS_LIBRARY_PERMISSION_READ].forEach(
    (id) => {
      const role1 = p1 ? p1.find((p) => p.Id === id) || emptyPermission : emptyPermission;
      const role2 = p2 ? p2.find((p) => p.Id === id) || emptyPermission : emptyPermission;
      if (!role1.Subjects.O2User) {
        role1.Subjects.O2User = [];
      }
      if (!role2.Subjects.O2User) {
        role2.Subjects.O2User = [];
      }
      newPermission.push({
        role: id,
        subjects: {
          o2Users: [...new Set(role1.Subjects.O2User.concat(role2.Subjects.O2User))],
        },
      });
    }
  );
  return newPermission;
};

export const getNamespacePermission = (env, namespaceId) => {
  const names = namespaceId.split('.');
  let path;
  let fssStatusLatest = null;
  if (env === ForgeEnvironmentEnum.STAGING) {
    fssStatusLatest = localStorage.FSSStgStatus ? JSON.parse(localStorage.FSSStgStatus) : {};
  } else if (env === ForgeEnvironmentEnum.PRODUCTION) {
    fssStatusLatest = localStorage.FSSProdStatus ? JSON.parse(localStorage.FSSProdStatus) : {};
  }
  let permissions;
  while (names.length > 0) {
    path = path ? path + '.' + names.shift() : names.shift();
    const nsInfo = fssStatusLatest[path];
    if (nsInfo && nsInfo.permissions) {
      if (permissions) {
        permissions = mergePermissions(permissions, nsInfo.permissions);
      } else {
        permissions = nsInfo.permissions;
      }
    }
  }
  return permissions || emptyPermission;
};

export const convertPathToTypeid = (path) => {
  const strings = path.split('/');
  strings.shift(); // remove "schemas".
  if (path.indexOf('.json') >= 0) {
    let typeid = strings.pop(); // remove json file name.
    typeid = typeid.substring(0, typeid.lastIndexOf('.')); // remove the extension - ".json"
    return strings.join('.') + ':' + typeid;
  } else {
    return strings.join('.');
  }
};

export const convertTypeidToPath = (typeid) => {
  const strs = typeid.split(':');
  return 'schemas/' + strs[0].replace(/\./g, '/') + '/' + strs[1] + '.json';
};

export const delay = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};
